import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

export const Root = styled(MenuItem)(({ theme, variant }) => ({
  display: 'flex',
  textTransform: 'capitalize',
  alignItems: 'center',
  padding: 0,
  ...theme.typography.body_largeRegular,
  '&:focus': {
    boxShadow: 'none'
  },
  '&:focus-visible': {
    outline: 'none'
  },
  '&:hover, &.Mui-focusVisible, & .active': {
    background: 'rgba(207, 249, 250, 0.4)'
  },
  '& a': {
    textDecoration: 'none',
    color: 'inherit',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    ...(variant === 'reserved' && {
      width: '100%',
      justifyContent: 'space-between'
    })
  },
  ...(variant === 'view-all' && {
    color: theme.palette.peace50.main
  })
}));
